import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useCourierContext } from "../../../Shared/CourierContext";
import BreadCrumbs from "../../../Utils/Common/Breadcrumb";
import { AutocompleteStyle } from "../../../Utils/MuiStyles/AutocompleteStyles";
import CancelOrder from "./CancelOrder";
import Pickup from "./Pickup";
import AddNewPickup from "./Pickup/AddNewPickup";
import PickupArchive from "./PickupArchive";
import Shipment from "./Shipment";
import AddNewShipment from "./Shipment/AddNewShipment";

import ShipmentArchive from "./ShipmentArchive"; 
import CancelShipment from "./CancelShipment";
import useLang from "Shared/hooks/useLanguage";


const TabSelected = styled(Tab)(AutocompleteStyle());

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export type CourierNameI = "UPS" | "FedEx";

const UpsPickupAndShipment = () => {
  const { t } = useLang();
  const [modalShow, setModalShow] = useState(false);
  const [modalShow1, setModalShow1] = useState(false);

  const {
    setCourierName,
    setSearchRequest,
    setSearchRequestShipment,
    setSearchRequestShipmentTracking,
    setTabs,
    tabs,
    courierName,
    initialSearchQuery,
    initialSearchQueryShipment,
    initialSearchQueryShipmentTracking,
  } = useCourierContext();

  const params = useParams().courierName;
  const navigate = useNavigate();

  const handleTabChanged = (_: React.SyntheticEvent, newValue: number) => {
    setTabs(newValue);
    setModalShow(false);
    setModalShow1(false);
  };

  useEffect(() => {
    let courier: CourierNameI | null = null;
    if (params === "UPS" || params === "FedEx") {
      courier = params;
      setCourierName(courier);
      setSearchRequest(initialSearchQuery);
      setSearchRequestShipment(initialSearchQueryShipment);
      setSearchRequestShipmentTracking(initialSearchQueryShipmentTracking);
      setModalShow(false);
      setModalShow1(false);
      setTabs(0);
    } else {
      navigate("/pickup-shipment/UPS");
    }
  }, [params]);

  const permissions =
    useSelector(
      (state: any) =>
        state?.Reducer?.selectedTenantInfo?.infomationOfLoggedUser?.permissions
    ) || [];

  const hasPermission = (
    moduleName: string,
    pageName: string,
    action: string
  ) => {
    return permissions.some(
      (p: any) =>
        p.subject.replace(/\n/g, "").toLowerCase() ===
          pageName.replace(/\n/g, "").toLowerCase() &&
        p.moduleName.replace(/\n/g, "").toLowerCase() ===
          moduleName.replace(/\n/g, "").toLowerCase() &&
        p.action.replace(/\n/g, "").toLowerCase() === action.toLowerCase()
    );
  };

  const canCancelOrder = hasPermission(
    "Shipping and Pickup",
    courierName === "FedEx"
      ? "FedEx Pickup and Shipment"
      : "UPS Pickup and Shipment",
    "Cancel"
  );


  const canCancelShipment = hasPermission(
    "Shipping and Pickup",
    courierName === "FedEx"
      ? "FedEx Pickup and Shipment"
      : "UPS Pickup and Shipment",
    "CancelShipment"
  );



  return (
    <>
      <div className="app-toolbar py-2 py-lg-3">
        <div className="app-container container-fluid d-flex flex-wrap gap-4 justify-content-center justify-content-sm-between align-items-center">
          <BreadCrumbs />
        </div>
      </div>
      <div className="d-flex flex-column flex-column-fluid">
        <div className="app-content flex-column-fluid">
          <div className="app-container container-fluid">
            <AddNewPickup modalShow={modalShow} setModalShow={setModalShow} />
            <AddNewShipment
              setModalShow={setModalShow1}
              modalShow={modalShow1}
            />
            <Tabs
              value={tabs}
              onChange={handleTabChanged}
              className="min-h-auto"
              TabIndicatorProps={{ style: { background: "transparent" } }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                "& .MuiTabs-scrollButtons": {
                  width: 0,
                  transition: "width 0.7s ease",
                  "&:not(.Mui-disabled)": {
                    width: "48px",
                  },
                },
              }}
            >
              <TabSelected
                label={t("Pickup")}
                {...a11yProps(0)}
                className="fw-bold text-capitalize"
                id={`pickup`}
              />
              {/* <TabSelected
                label={t("Shipment Tracking")}
                {...a11yProps(2)}
                className="fw-bold text-capitalize"
                /> */}
              <TabSelected
                label={t("Pickup Archive")}
                {...a11yProps(1)}
                className="fw-bold text-capitalize"
                id={`PickUpArchive`}
              />

             
                <TabSelected
                  label={t("Cancel Order")}
                  {...a11yProps(2)}
                  className="fw-bold text-capitalize"
                   sx={{ display: canCancelOrder ? "flex" : "none" }}  
                  id={`CancelOrder`}
                />
          

                    <TabSelected
                label={t("Shipment")}
                {...a11yProps(3)}
                className="fw-bold text-capitalize"
                id={`Shipment`}
              />

              <TabSelected
                label={t("Shipment Archive")}
                {...a11yProps(4)}
                className="fw-bold text-capitalize"
              /> 

              <TabSelected
                label={t("Cancel Shipment")}
                {...a11yProps(5)}/>
              {/* <TabSelected
                label={t("Shipment Tracking Archive")}
                {...a11yProps(5)}
                className="fw-bold text-capitalize"
              /> */}
            </Tabs>
            <div className="card rounded-top-0 shadow-none">
                <TabPanel value={tabs} index={0}>
                  <Pickup setModalShow={setModalShow} />
                </TabPanel>
                {/* <TabPanel value={tabs} index={2}>
                  <ShipmentTracking />
                  </TabPanel> */}
                <TabPanel value={tabs} index={1}>
                  <PickupArchive />
                </TabPanel>

                <TabPanel value={tabs} index={2}>
                  <CancelOrder />
                </TabPanel>

                <TabPanel value={tabs} index={3}>
                  <Shipment setModalShow={setModalShow1} />
                </TabPanel>
                <TabPanel value={tabs} index={4}>
                  <ShipmentArchive />
                </TabPanel>

                 <TabPanel value={tabs} index={5}>
                  <CancelShipment />
                </TabPanel>
                {/* <TabPanel value={tabs} index={5}>
                  <ShipmentTrackingArchive />
                </TabPanel> */}
              </div>
            </div>
          </div>
        </div>
     
    </>
  );
};
export default UpsPickupAndShipment;
